module.exports = __webpack_public_path__ + "img/7.c8d6ccff.svg";